//Include Both Helper File with needed methods
// Not: JWT token'ı istemci tarafında DECODE ETMEZ veya doğrulamaya çalışmaz.
// Rol/yetki kararlarının her birinde backend yeniden kontrol eder.

import { postLogin } from 'helpers/backend_helper'
import { toast } from 'react-toastify'

import { loginSuccess, logoutUserSuccess, apiError, reset_login_flag } from './reducer'

export const loginUser = (user: any, history: any) => async (dispatch: any) => {
  try {
    let response
    if (process.env.REACT_APP_API_URL) {
      response = postLogin({
        email: user.email,
        password: user.password
      })
    } else {
      // Fallback to fake backend if no API URL
      response = postLogin({
        email: user.email,
        password: user.password
      })
    }

    const res = await response

    if (res?.token) {
      sessionStorage.setItem('authUser', JSON.stringify(res.user))
      sessionStorage.setItem('jwtToken', res.token)

      // Handle user roles/permissions
      if (res.user?.role) {
        const isAdmin = res.user.role === 'superAdmin' || res.user.role === 'admin'
        sessionStorage.setItem('userType', isAdmin ? '1' : '2')

        if (isAdmin) {
          // Admins get all permissions
          sessionStorage.removeItem('userRoles')
        } else if (res.user.pagePermissions) {
          // Operators get specific page permissions
          sessionStorage.setItem(
            'userRoles',
            btoa(JSON.stringify(res.user.pagePermissions))
          )
        }
      }

      dispatch(loginSuccess(res))

      // Navigate to first accessible page
      const isAdminUser = res.user.role === 'superAdmin' || res.user.role === 'admin'
      if (isAdminUser) {
        history('/sales')
      } else {
        const pageRouteMap: Record<string, string> = {
          Sales: '/sales',
          Booths: '/booths',
          Locations: '/locations',
          Services: '/services',
          Promotions: '/promotions',
          'Promotion Booths': '/promotion-booths',
          Backgrounds: '/backgrounds',
          'Effects/Filters': '/effects',
          'Camera Settings': '/camera-settings',
          Users: '/users'
        }
        const firstPage = (res.user.pagePermissions || []).find((p: any) => p.canView)
        const route = firstPage ? pageRouteMap[firstPage.page] || '/sales' : '/sales'
        history(route)
      }
    } else {
      const errMsg = res?.message || ('' as any)
      dispatch(apiError(errMsg))
      toast.error('You have entered an invalid email or password. Please try again!')
    }
  } catch (error: any) {
    dispatch(apiError(error))
    toast.error('You have entered an invalid email or password. Please try again!')
  }
}

export const logoutUser = () => async (dispatch: any) => {
  try {
    sessionStorage.removeItem('authUser')
    sessionStorage.removeItem('jwtToken')
    sessionStorage.removeItem('userType')
    sessionStorage.removeItem('userRoles')
    dispatch(logoutUserSuccess(true))
  } catch (error: any) {
    dispatch(apiError(error))
  }
}

export const resetLoginFlag = () => async (dispatch: any) => {
  try {
    const response = dispatch(reset_login_flag())
    return response
  } catch (error: any) {
    dispatch(apiError(error))
  }
}
